module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_long_back_vector.4eac3bd5.svg";